export function FormatBooleanYesNo(value: boolean) {
	return value ? "Yes" : "No";
}